<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_3964_20750)">
      <path
        d="M11.6733 2.58039L10.4866 1.40039L3.89331 8.00039L10.4933 14.6004L11.6733 13.4204L6.25331 8.00039L11.6733 2.58039Z"
        fill="#323232"
      />
    </g>
    <defs>
      <clipPath id="clip0_3964_20750">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
